"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2022 BLUECROSS BLUESHIELD OF SOUTH CAROLINA ALL RIGHTS RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coverage = exports.HttpErrorCode = exports.HttpMethod = exports.Constituent = void 0;
/**
 * enums used in the applications
 */
/**
 * the constituents
 * - member
 * - provider
 * - employer
 */
var Constituent;
(function (Constituent) {
    Constituent["MEMBER"] = "member";
    Constituent["PROVIDER"] = "provider";
    Constituent["EMPLOYER"] = "employer";
})(Constituent = exports.Constituent || (exports.Constituent = {}));
const ConstituentValueMap = {
    [Constituent.MEMBER]: 'member',
    [Constituent.PROVIDER]: 'provider',
    [Constituent.EMPLOYER]: 'employer'
};
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["PATCH"] = "PATCH";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
/**
 * Provide an enumeration for http error codes
 */
var HttpErrorCode;
(function (HttpErrorCode) {
    /**
     * LEDS Token expired
     */
    HttpErrorCode[HttpErrorCode["LEDS_TOKEN_EXPIRED"] = 419] = "LEDS_TOKEN_EXPIRED";
    HttpErrorCode[HttpErrorCode["COMM_SERVICES_TOKEN_EXPIRED"] = 401] = "COMM_SERVICES_TOKEN_EXPIRED";
})(HttpErrorCode = exports.HttpErrorCode || (exports.HttpErrorCode = {}));
/**
 * The Insurance Coverage Types
 */
var Coverage;
(function (Coverage) {
    Coverage["HEALTH"] = "HEALTH";
    Coverage["DENTAL"] = "DENTAL";
    Coverage["DRUG"] = "DRUG";
    Coverage["VISION"] = "VISION";
    Coverage["UNKNOWN"] = "";
})(Coverage = exports.Coverage || (exports.Coverage = {}));
//# sourceMappingURL=index.js.map